import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=2081a223&scoped=true&"
import script from "@/views/Home/Home.ts?vue&type=script&lang=ts&"
export * from "@/views/Home/Home.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Home/Home.scss?vue&type=style&index=0&id=2081a223&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2081a223",
  null
  
)

export default component.exports